import { ContinueOnComputerPage } from '../../pages/ContinueOnComputerPage'
import { CountryPage } from '../../pages/CountryPage'
import { DeviceSwitchedPage } from '../../pages/DeviceSwitchedPage'
import { DocumentTypePage } from '../../pages/DocumentTypePage'
import { GeneralConditionsPage } from '../../pages/GeneralConditionsPage'
import { IncorrectPinCodePage } from '../../pages/IncorrectPinCodePage'
import { GoToMobileThankYouPage } from '../../pages/GoToMobileThankYouPage'
import { InitialPage } from '../../pages/InitialPage'
import { MicropaymentFintecPage } from '../../pages/MicropaymentFintecPage'
import { MicropaymentFintecAmexPage } from '../../pages/amex/MicropaymentFintecAmexPage'
import { MicropaymentInfoPage } from '../../pages/MicropaymentInfoPage'
import { MicropaymentInfoAmexPage } from '../../pages/amex/MicropaymentInfoAmexPage'
import { MocksPage } from '../../pages/MocksPage'
import { OtpPage } from '../../pages/OtpPage'
import { PixelSpeakPage } from '../../pages/PixelSpeakPage'
import { ProgressPage } from '../../pages/ProgressPage'
import { SignDocumentPage } from '../../pages/SignDocumentPage'
import { UserDataPage } from '../../pages/UserDataPage'
import { PlaceOfBirthPage } from '../../pages/PlaceOfBirthPage'
import { VideoIdPage } from '../../pages/VideoIdPage'
import { VideoOnboardingPage } from '../../pages/VideoOnboardingPage'
import { DTPWaitingPage } from '../../pages/dtp/DTPWaiting'
import { DTPInfoPage } from '../../pages/dtp/DTPInfoPage'
import { WaitingAfterGoToMobilePage } from '../../pages/WaitingAfterGoToMobilePage'
import { TermsAndConditionsDTPInfoPage } from '../../pages/dtp/TermsAndConditionsDTPInfoPage'
import { VerifyingPage } from '../../pages/VerifyingPage'
import { AccountHolderMockPage } from '../../pages/AccountHolderMockPage'
import { AddressUploadBackSideIkanoPage } from '../../pages/ikano/AddressUploadBackSideIkanoPage'
import { AddressUploadBothSidesIkanoPage } from '../../pages/ikano/AddressUploadBothSidesIkanoPage'
import { AddressUploadFrontSideIkanoPage } from '../../pages/ikano/AddressUploadFrontSideIkanoPage'
import { AddressUploadIkanoPage } from '../../pages/ikano/AddressUploadIkanoPage'
import { AddressVerificationIkanoPage } from '../../pages/ikano/AddressVerificationIkanoPage'
import { AddressVerificationTwoSidedIkanoPage } from '../../pages/ikano/AddressVerificationTwoSidedIkanoPage'
import { CompleteIkanoPage } from '../../pages/ikano/CompleteIkanoPage'
import { SuccessEidCmcPage } from '@/pages/cmc/SuccessEidCmcPage'
import { SuccessEnpalPage } from '@/pages/enpal/SuccessEnpalPage'
import { SuccessSesEnpalPage } from '@pages/enpal/SuccessSesEnpalPage'
import { IdentityVerificationEnpalPage } from '@pages/enpal/IdentityVerificationEnpalPage'
import { IdentityVerificationPage } from '@pages/IdentityVerificationPage'
import { WelcomeEnpalPage } from '@pages/enpal/WelcomeEnpalPage'
import { ContinueOnMobilePage } from '../../pages/ContinueOnMobilePage'
import { SwitchToMobileEnpalPage } from '../../pages/enpal/SwitchToMobileEnpalPage'
import { SwitchToMobileWithHowtoPage } from '../../pages/SwitchToMobileWithHowtoPage'
import { GeneralConditionsWithMicropaymentIkanoPage } from '../../pages/ikano/GeneralConditionsWithMicropaymentIkanoPage'
import { TermsAndConditionsWithMicropaymentIkanoPage } from '../../pages/ikano/TermsAndConditionsWithMicropaymentIkanoPage'
import { MicropaymentFintecIkanoPage } from '../../pages/ikano/MicropaymentFintecIkanoPage'
import { MicropaymentInfoIkanoPage } from '../../pages/ikano/MicropaymentInfoIkanoPage'
import { MicropaymentInfoIkanoOpenBankingPage } from '../../pages/ikano/MicropaymentInfoIkanoOpenBankingPage'
import { TermsAndConditionsMicropaymentInfoIkanoOpenBankingPage } from '../../pages/ikano/TermsAndConditionsMicropaymentInfoIkanoOpenBankingPage'
import { MicropaymentInfoWithVideoIdIkanoPage } from '../../pages/ikano/MicropaymentInfoWithVideoIdIkanoPage'
import { MicropaymentReversedInfoWithVideoIdIkanoPage } from '../../pages/ikano/MicropaymentReversedInfoWithVideoIdIkanoPage'
import { SwitchToMobilePage } from '../../pages/SwitchToMobilePage'
import { ResumeFromEmailPage } from '../../pages/ResumeFromEmailPage'
import { AddressUploadPageKontomatik } from '../../pages/kontomatik/AddressUploadPageKontomatik'
import { IntroKontomatikPage } from '../../pages/kontomatik/IntroKontomatikPage'
import { KontomatikPage } from '../../pages/kontomatik/KontomatikPage'
import { ProgressPageKontomatik } from '../../pages/kontomatik/ProgressPageKontomatik'
import { BankIdRetryPage } from '../../pages/BankIdRetryPage'
import { BankSelectionPage } from '../../pages/BankSelectionPage'
import { GeneralConditionsBeforeBankSelectionPage } from '../../pages/GeneralConditionsBeforeBankSelectionPage'
import { TermsAndConditionsPage } from '../../pages/TermsAndConditionsPage'
import { SaltedgePage } from '../../pages/SaltedgePage'
import { SaltedgeRedirectPage } from '../../pages/SaltedgeRedirectPage'
import { SaltedgeReturnPage } from '../../pages/SaltedgeReturnPage'
import { ErrorIosBrowserNotSupportedPage } from '../../pages/ErrorIosBrowserNotSupportedPage'
import { SignDocumentEnpalPage } from '@/pages/enpal/SignDocumentEnpalPage'
import { DocumentTypeEnpalPage } from '@/pages/enpal/DocumentTypeEnpalPage'
import { ErrorPage } from '../../pages/ErrorPage'
import { NotFoundPage } from '../../pages/NotFoundPage'
import { OpenbankingMastercardPage } from '@/pages/mastercard/OpenbankingMastercardPage'
import { SignDocumentSantanderPage } from '@/pages/santander/SignDocumentSantanderPage'
import { VerifiedSantanderPage } from '@/pages/santander/VerifiedSantanderPage'
import { OnfidoPage } from '@/pages/OnfidoPage'
import { MicropaymentInfoDocusignPage } from '@/pages/docusign/MicropaymentInfoDocusignPage'
import { LtqcSignPage } from '@pages/LtqcSignPage'
import { LtqcSignDocumentPage } from '@pages/LtqcSignDocumentPage'
import { LtqcSignVerifiedPage } from '@pages/LtqcSignVerifiedPage'
import { EnrollmentStartPage } from '@pages/enrollment/EnrollmentStartPage'
import { EnrollmentVerificationPage } from '@/pages/enrollment/EnrollmentVerificationPage'
import { EnrollmentAcceptCertificatePage } from '@/pages/enrollment/EnrollmentAcceptCertificatePage'
import { EnrollmentCreatePasswordPage } from '@pages/enrollment/EnrollmentCreatePasswordPage'
import { EnrollmentVerifiedPage } from '@/pages/enrollment/EnrollmentVerifiedPage'
import { EnrollmentVideoIdPage } from '@/pages/enrollment/EnrollmentVideoIdPage'
import { SuccessPage } from '@/pages/SuccessPage'
import { SuccessWithVideoEnpalPage } from '@/pages/enpal/SuccessWithVideoEnpalPage'
import { EidMethodSelectionPage } from '@/pages/EidMethodSelectionPage'
import { VideoIdEnpalPage } from '@/pages/enpal/VideoIdEnpalPage'
import { SuccessElavonPage } from '@/pages/elavon/SuccessElavonPage'
import { GocardlessCountryPage } from '@/pages/gocardless/GocardlessCountryPage'
import { EidElavonPage } from '@/pages/elavon/EidElavonPage'
import { GocardlessCheckPage } from '@/pages/gocardless/GocardlessCheckPage'
import { ErrorEidElavonPage } from '@/pages/elavon/ErrorEidElavonPage'
import { ErrorGocardlessElavonPage } from '@/pages/elavon/ErrorGocardlessElavonPage'
import { EidPage } from '@/pages/EidPage'
import { TermsAndConditionsElavonPage } from '@/pages/elavon/TermsAndConditionsElavonPage'
import { DataCollectionPage } from '@/pages/dataCollection/DataCollectionPage'
import { GocardlessBankSelectionPage } from '@/pages/GocardlessBankSelectionPage'
import { GocardlessProcessingPage } from '@/pages/gocardless/GocardlessProcessingPage'
import { GocardlessIncomeConfirmationPage } from '@/pages/gocardless/GocardlessIncomeConfirmationPage'
import { GocardlessBankSelectionWithButtonPage } from '@/pages/gocardless/GocardlessBankSelectionWithButtonPage'
import { SignDocumentOnventisPage } from '@/pages/onventis/SignDocumentOnventisPage'
import { SuccessOnventisPage } from '@/pages/onventis/SuccessOnventisPage'
import { SignRejectionPage } from '@/pages/SignRejectionPage'
import { SignDocumentWithStampsPage } from '@/pages/SignDocumentWithStampsPage'
import { EasySignDocumentPage } from '@/pages/easysign/EasySignDocumentPage'
import { EasySignSignaturePage } from '@/pages/easysign/EasySignSignaturePage'
import { EasySignSmsOtpVerificationPage } from '@/pages/easysign/EasySignSmsOtpVerificationPage/EasySignSmsOtpVerificationPage'
import { EasySignWaitProceedPage } from '@/pages/easysign/EasySignWaitProceedPage'
import { EasySignWaitCompletePage } from '@/pages/easysign/EasySignWaitCompletePage'
import { SigningWaitingPage } from '@/pages/SigningWaitingPage'
import { GocardlessTransactionDataSelectionPage } from '@/pages/GocardlessTransactionDataSelectionPage'
import { GocardlessCustomTransactionDataPage } from '@/pages/GocardlessCustomTransactionDataPage'
import { SuccessEidElavonPage } from '@/pages/elavon/SuccessEidElavonPage'
import { PendingSignatoriesPage } from '@/pages/PendingSignatoriesPage'
import { SignDocumentIkanoPage } from '@/pages/ikano/SignDocumentIkanoPage'
import { SignDocumentAmexPage } from '@/pages/amex/SignDocumentAmexPage/SignDocumentAmexPage'
import { AddressUploadAmexGreatPage } from '@/pages/amex/great/AddressUploadAmexGreatPage'
import { GeneralConditionsAmexGreatPage } from '@/pages/amex/great/GeneralConditionsAmexGreatPage'
import { UserDataAmexGreatPage } from '@/pages/amex/great/UserDataAmexGreatPage'
import { SignDocumentAmexGreatPage } from '@/pages/amex/great/SignDocumentAmexGreatPage'
import { DocumentTypeAmexGreatPage } from '@/pages/amex/great/DocumentTypeAmexGreatPage'
import { PlaceOfBirthAmexGreatPage } from '@/pages/amex/great/PlaceOfBirthAmexGreatPage'
import { VideoOnboardingAmexGreatPage } from '@/pages/amex/great/VideoOnboardingAmexGreatPage'
import { VideoIdAmexGreatPage } from '@/pages/amex/great/VideoIdAmexGreatPage'
import { EidAmexGreatPage } from '@/pages/amex/great/EidAmexGreatPage'
import { ReadIdAmexGreatPage } from '@/pages/amex/great/ReadIdAmexGreatPage'
import { ReadIdCompletedAmexGreatPage } from '@/pages/amex/great/ReadIdCompletedAmexGreatPage'
import { WalletVerificationAmexGreatPage } from '@/pages/amex/great/WalletVerificationAmexGreatPage'
import { SignatureOtpPage } from '../../pages/SignatureOtpPage'
import { VideoIdForStandardSignaturePage } from '../../pages/VideoIdForStandardSignaturePage'
import { VideoVerifyingPage } from '../../pages/VideoVerifyingPage'
import { ThemePage } from '@/pages/ThemePage'
import { TransactionCompletedPage } from '@/pages/TransactionCompletedPage'
import { ReadIdPage } from '@/pages/ReadIdPage'
import { ReadIdCompletedPage } from '@/pages/ReadIdCompletedPage'
import { WalletVerificationPage } from '@/pages/WalletVerificationPage'
import { EasySignHandwrittenSignaturePage } from '@/pages/easysign/EasySignHandwrittenSignaturePage'
import { AgeVerificationStartPage } from '@/pages/ageVerification/AgeVerificationStartPage'
import { AgeVerificationRegistrationPage } from '@/pages/ageVerification/AgeVerificationRegistrationPage'
import { AgeVerificationStatusPage } from '@/pages/ageVerification/AgeVerificationStatusPage'
import { AgeVerificationCompletePage } from '@/pages/ageVerification/AgeVerificationCompletePage'

export const PAGES = {
  DataCollection: DataCollectionPage,
  GeneralConditions: GeneralConditionsPage,
  SignDocument: SignDocumentPage,
  VideoId: VideoIdPage,
  Otp: OtpPage,
  DocumentType: DocumentTypePage,
  Country: CountryPage,
  UserData: UserDataPage,
  PlaceOfBirth: PlaceOfBirthPage,
  VideoOnboarding: VideoOnboardingPage,
  MicropaymentFintec: MicropaymentFintecPage,
  MicropaymentFintecAmex: MicropaymentFintecAmexPage,
  MicropaymentFintecIkano: MicropaymentFintecIkanoPage,
  Mocks: MocksPage,
  Initial: InitialPage,
  Progress: ProgressPage,
  IntroKontomatik: IntroKontomatikPage,
  KontomatikPage: KontomatikPage,
  ProgressPageKontomatik: ProgressPageKontomatik,
  AddressUploadPageKontomatik: AddressUploadPageKontomatik,
  MicropaymentInfoIkano: MicropaymentInfoIkanoPage,
  MicropaymentInfoIkanoOpenBanking: MicropaymentInfoIkanoOpenBankingPage,
  TermsAndConditionsMicropaymentInfoIkanoOpenBanking:
    TermsAndConditionsMicropaymentInfoIkanoOpenBankingPage,
  GeneralConditionsWithMicropaymentIkano: GeneralConditionsWithMicropaymentIkanoPage,
  TermsAndConditionsWithMicropaymentIkano: TermsAndConditionsWithMicropaymentIkanoPage,
  MicropaymentInfoWithVideoIdIkano: MicropaymentInfoWithVideoIdIkanoPage,
  MicropaymentReversedInfoWithVideoIdIkano: MicropaymentReversedInfoWithVideoIdIkanoPage,
  SuccessEidCmc: SuccessEidCmcPage,
  SuccessEnpal: SuccessEnpalPage,
  SuccessSesEnpal: SuccessSesEnpalPage,
  SuccessWithVideoEnpal: SuccessWithVideoEnpalPage,
  WelcomeEnpal: WelcomeEnpalPage,
  IdentityVerificationEnpal: IdentityVerificationEnpalPage,
  IdentityVerification: IdentityVerificationPage,
  CompleteIkano: CompleteIkanoPage,
  SignDocumentEnpal: SignDocumentEnpalPage,
  DocumentTypeEnpal: DocumentTypeEnpalPage,
  SignDocumentSantander: SignDocumentSantanderPage,
  VerifiedSantander: VerifiedSantanderPage,
  PixelSpeakPage: PixelSpeakPage,
  AddressVerificationIkano: AddressVerificationIkanoPage,
  AddressUploadIkano: AddressUploadIkanoPage,
  AddressVerificationTwoSidedIkano: AddressVerificationTwoSidedIkanoPage,
  AddressUploadFrontSideIkano: AddressUploadFrontSideIkanoPage,
  AddressUploadBackSideIkano: AddressUploadBackSideIkanoPage,
  AccountHolderMock: AccountHolderMockPage,
  AddressUploadBothSidesIkano: AddressUploadBothSidesIkanoPage,
  SwitchToMobile: SwitchToMobilePage,
  SwitchToMobileEnpal: SwitchToMobileEnpalPage,
  SwitchToMobileWithHowto: SwitchToMobileWithHowtoPage,
  ContinueOnMobile: ContinueOnMobilePage,
  ResumeFromEmail: ResumeFromEmailPage,
  DTPWaiting: DTPWaitingPage,
  DTPInfo: DTPInfoPage,
  WaitingAfterGoToMobile: WaitingAfterGoToMobilePage,
  TermsAndConditionsDTPInfo: TermsAndConditionsDTPInfoPage,
  Verifying: VerifyingPage,
  IncorrectPinCode: IncorrectPinCodePage,
  GoToMobileThankYou: GoToMobileThankYouPage,
  DeviceSwitched: DeviceSwitchedPage,
  ContinueOnComputer: ContinueOnComputerPage,
  MicropaymentInfo: MicropaymentInfoPage,
  MicropaymentInfoAmex: MicropaymentInfoAmexPage,
  BankIdRetry: BankIdRetryPage,
  BankSelection: BankSelectionPage,
  GocardlessCheck: GocardlessCheckPage,
  GocardlessCountry: GocardlessCountryPage,
  GocardlessBankSelection: GocardlessBankSelectionPage,
  GocardlessProcessing: GocardlessProcessingPage,
  GocardlessIncomeConfirmation: GocardlessIncomeConfirmationPage,
  GocardlessBankSelectionWithButton: GocardlessBankSelectionWithButtonPage,
  GocardlessTransactionDataSelection: GocardlessTransactionDataSelectionPage,
  GocardlessCustomTransactionData: GocardlessCustomTransactionDataPage,
  GeneralConditionsBeforeBankSelection: GeneralConditionsBeforeBankSelectionPage,
  TermsAndConditions: TermsAndConditionsPage,
  Saltedge: SaltedgePage,
  SaltedgeRedirect: SaltedgeRedirectPage,
  SaltedgeReturn: SaltedgeReturnPage,
  ErrorIosBrowserNotSupported: ErrorIosBrowserNotSupportedPage,
  NotFound: NotFoundPage,
  Error: ErrorPage,
  OpenbankingMastercard: OpenbankingMastercardPage,
  Onfido: OnfidoPage,
  MicropaymentInfoDocusign: MicropaymentInfoDocusignPage,
  VideoIdEnpal: VideoIdEnpalPage,
  LtqcSign: LtqcSignPage,
  LtqcSignDocument: LtqcSignDocumentPage,
  LtqcSignVerified: LtqcSignVerifiedPage,
  EnrollmentStart: EnrollmentStartPage,
  EnrollmentVideoId: EnrollmentVideoIdPage,
  EnrollmentVerification: EnrollmentVerificationPage,
  EnrollmentAcceptCertificate: EnrollmentAcceptCertificatePage,
  EnrollmentCreatePassword: EnrollmentCreatePasswordPage,
  EnrollmentVerified: EnrollmentVerifiedPage,
  Success: SuccessPage,
  EidMethodSelection: EidMethodSelectionPage,
  SuccessElavon: SuccessElavonPage,
  SuccessEidElavon: SuccessEidElavonPage,
  EidElavon: EidElavonPage,
  ErrorEidElavon: ErrorEidElavonPage,
  ErrorGocardlessElavon: ErrorGocardlessElavonPage,
  TermsAndConditionsElavon: TermsAndConditionsElavonPage,
  Eid: EidPage,
  SignDocumentOnventis: SignDocumentOnventisPage,
  SuccessOnventis: SuccessOnventisPage,
  SignDocumentWithStamps: SignDocumentWithStampsPage,
  SignRejection: SignRejectionPage,
  EasySignDocument: EasySignDocumentPage,
  EasySignSignature: EasySignSignaturePage,
  EasySignSmsOtpVerification: EasySignSmsOtpVerificationPage,
  EasySignWaitProceed: EasySignWaitProceedPage,
  EasySignWaitComplete: EasySignWaitCompletePage,
  SigningWaiting: SigningWaitingPage,
  PendingSignatories: PendingSignatoriesPage,
  SignDocumentIkano: SignDocumentIkanoPage,
  SignDocumentAmex: SignDocumentAmexPage,
  AddressUploadAmexGreat: AddressUploadAmexGreatPage,
  GeneralConditionsAmexGreat: GeneralConditionsAmexGreatPage,
  UserDataAmexGreat: UserDataAmexGreatPage,
  SignDocumentAmexGreat: SignDocumentAmexGreatPage,
  DocumentTypeAmexGreat: DocumentTypeAmexGreatPage,
  PlaceOfBirthAmexGreat: PlaceOfBirthAmexGreatPage,
  VideoOnboardingAmexGreat: VideoOnboardingAmexGreatPage,
  VideoIdAmexGreat: VideoIdAmexGreatPage,
  EidAmexGreat: EidAmexGreatPage,
  ReadIdAmexGreat: ReadIdAmexGreatPage,
  ReadIdCompletedAmexGreat: ReadIdCompletedAmexGreatPage,
  WalletVerificationAmexGreat: WalletVerificationAmexGreatPage,
  SignatureOtp: SignatureOtpPage,
  VideoIdForStandardSignature: VideoIdForStandardSignaturePage,
  VideoVerifying: VideoVerifyingPage,
  Theme: ThemePage,
  TransactionCompleted: TransactionCompletedPage,
  ReadId: ReadIdPage,
  ReadIdCompleted: ReadIdCompletedPage,
  WalletVerification: WalletVerificationPage,
  EasySignHandwrittenSignature: EasySignHandwrittenSignaturePage,
  AgeVerificationStart: AgeVerificationStartPage,
  AgeVerificationRegistration: AgeVerificationRegistrationPage,
  AgeVerificationStatus: AgeVerificationStatusPage,
  AgeVerificationComplete: AgeVerificationCompletePage,
}

export const PAGES_WITHOUT_KEEP_ALIVE = [
  'Initial',
  'VideoId',
  'MicropaymentFintec',
  'AddressUploadPageKontomatik',
  'Otp',
  'CompleteIkano',
  'CompleteEnpal',
  'VideoIdIkano',
  'ErrorPage',
  'Mocks',
  'IncorrectPinCode',
  'GoToMobileThankYou',
  'DeviceSwitched',
  'ContinueOnComputer',
  'ContinueOnMobile',
  'SuccessEnpal',
  'Theme',
  'SuccessSesEnpal',
  'SuccessWithVideoEnpal',
  'LtqcSignVerified',
  'EnrollmentVerified',
  'Verifying',
  'IdentityVerificationEnpal',
  'IdentityVerification',
  'WelcomeEnpal',
  'VideoIdEnpal',
  'Success',
  'EidMethodSelection',
  'SuccessElavon',
  'VerifiedSantander',
  'SigningWaiting',
  'SuccessEidCmc',
  'SuccessOnventis',
  'SignRejection',
  'NotFound',
  'Error',
  'TransactionCompleted',
  'ReadIdCompleted',
  'ReadIdCompletedAmexGreat',
  'AgeVerificationStatus',
  'AgeVerificationComplete',
  // The GoCardless return page can be opened in a browser that never held the
  // onboarding session cookie, so the heartbeat would only get a 401 — and the
  // axios interceptor turns that into a redirect to `session-unauthorized`,
  // throwing the user out of the page seconds after they land on it. sc-21124
  'GocardlessProcessing',
  // Reached from that return page (or from the backend's redirect) in the same browser, with only
  // the GoCardless session cookie - same reasoning.
  'GocardlessIncomeConfirmation',
]
